import { useQuery } from "@tanstack/react-query";

import { generateCmcMixCopy } from "services";

import { GENERATE_CMC_MIX_COPY } from "consts";

import { CmcMixCopyRequest } from "models";

export const useGenerateCmcMixCopy = (request: CmcMixCopyRequest | null) =>
  useQuery({
    queryKey: [GENERATE_CMC_MIX_COPY, request],
    queryFn: ({ signal }) => generateCmcMixCopy({ requestBody: request!, signal }),
    enabled: request !== null,
    staleTime: Infinity,
    retry: false,
  });
